export default __webpack_public_path__ + "static/media/pexels-ann-nekr-5797899.3d8c1458.jpg";